'use client';

import { clientSelectionLabels } from '../../utils/clientSelectionLabels';

interface ClientsExportLimitAlertProps {
  maxClients: number;
  hasFilters?: boolean;
}

export const ClientsExportLimitAlert = ({ maxClients, hasFilters = true }: ClientsExportLimitAlertProps) => (
  <div className="rounded-lg bg-red-300 px-4 py-2 text-body-small text-red-600" role="alert">
    {clientSelectionLabels.exportOverLimit({ maxClients, hasFilters })}
  </div>
);
